import Vue from 'vue'

import ElementUI from 'element-ui'
import 'element-ui/lib/theme-chalk/index.css'

import moment from 'moment'
import 'moment/locale/zh-cn'

import app from './App.vue'
import store from './store'
import router from './router'
import http from './libs/http'
import Print from 'vue-print-nb'
moment.locale('zh-cn')

Vue.config.productionTip = false

Vue.prototype.$moment = moment

Vue.prototype.$http = http

Vue.use(ElementUI)
Vue.use(Print)

const hasRole = function(role) {
    let user = store.state.User
    if (role === 'auth' && user !== undefined && user.id) {
        return true
    }
    if (!user || (!user.role && !user.type)) {
        return false
    }
    if (user.type && role.toLowerCase().startsWith(user.type.toLowerCase())) {
        return true
    }
    if (user.role && role.toLowerCase() === user.role.toLowerCase()) {
        return true
    }
    return false
}

Vue.prototype.$has = hasRole

Vue.directive('has', {
    bind: function(el, binding) {
        let flg = false
        if (binding.value.indexOf(',') >= 0) {
            for (let role of binding.value.split(',')) {
                flg = hasRole(role)
                if (flg) break
            }
        } else {
            flg = hasRole(binding.value)
        }
        if (!flg) {
            if (el.parentNode) {
                el.parentNode.removeChild(el)
            } else {
                el.style.display = 'none'
            }
        }
    }
})

Vue.filter('fmtRate', function(value) {
    return (value * 100).toFixed(2) + '%'
})

new Vue({
    router,
    store,
    beforeMount() {
        let self = document.getElementById('bootSpinner')
        self.parentElement.removeChild(self)
    },
    render: h => h(app)
}).$mount('#app')
